import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import TranslationsProvider from '@client/components/shared/translation/TranslationsProvider';
import TranslationsScope from '@client/components/shared/translation/TranslationsScope';
import { ConfigProvider, configShape } from '@client/hoc/config';
import '@client/styles/core.scss';

/* eslint-disable react/prop-types */
export default function AppRoot({ store, routes, history, translations, config }) {
    return (
        <ConfigProvider config={config}>
            <TranslationsProvider translations={translations}>
                <TranslationsScope>
                    <Provider store={store}>
                        <Router
                            history={history}
                        >
                            {routes}
                        </Router>
                    </Provider>
                </TranslationsScope>
            </TranslationsProvider>
        </ConfigProvider>
    );
}

AppRoot.propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.object.isRequired,
    history: PropTypes.object,
    translations: PropTypes.object.isRequired,
    config: configShape.isRequired
};
